module.exports = __webpack_public_path__ + "img/fernao-po-adega.3960f4b5.jpg";